<template>
  <div
    v-if="hasFaq"
    class="container faq-v2-wrapper w-full py-12 md:py-20 md:max-w-2xl"
    data-test-id="component-faq-v2"
  >
    <div class="flex flex-col items-center">
      <SharedTextSectionHeader :title="title" data-test-id="text-faq-v2-title" spacing="bottom" />
      <div
        data-test-id="block-faq-v2-questions"
        class="block-faq-v2-questions flex flex-col items-center w-full md:my-8"
      >
        <div
          v-for="(faq, index) in list"
          :key="index"
          no-body
          class="block-faq-v2-question py-standart md:py-semi cursor-pointer"
          :data-test-id="`block-faq-v2-question-${index}`"
          @click="show(index)"
        >
          <span
            class="flex relative items-start"
            :data-test-id="`button-faq-v2-question-${index}`"
          >
            <p
              class="font-medium text-smaller md:text-base m-0 flex-grow"
              :data-test-id="`text-faq-v2-question-${index}`"
            >
              {{ faq.question }}
            </p>
            <div><MajorityUiMajorityIcon icon="plus" class="right-0 top-0 inline-block transition-transform duration-300 origin-center text-infra-violette" :class="{ 'transform rotate-45': index === shownIndex }" /></div>
          </span>
          <MajorityUiMajorityCollapseBox
            :open="index === shownIndex"
            class="mt-tiny"
            :data-test-id="`block-faq-v2-anweser-${index}`"
          >
            <p
              class="m-0 text-darker-grey text-smaller md:text-base font-light"
            >
              {{ faq.answer }}
            </p>
          </MajorityUiMajorityCollapseBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    faqs: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      shownIndex: null
    }
  },
  computed: {
    hasFaq () {
      return this.list.length > 0
    },
    list () {
      return Object.keys(this.faqs).map((key) => { return { ...this.faqs[key] } })
    }
  },
  methods: {
    show (index) {
      if (this.shownIndex === index) {
        this.shownIndex = null
      } else {
        this.shownIndex = index
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.block-faq-v2-questions {
  & > * {
    border-color: #f3efed;
    border-width: 1px 0 0;
    &:last-child {
      border-width: 1px 0;
    }
    @screen md {
      border-color: #d9d9d9;
    }
  }
}
.block-faq-v2-question {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    max-width: 100%;
}
</style>
